
const QuoteConfirmation = ({ onNext, currentData }) => {
  const pstHour = new Date().toLocaleString("en-US", { timeZone: "America/Los_Angeles", hour: "numeric", hour12: false });
  const hour = parseInt(pstHour, 10);
  const isDuringBusinessHours = hour >= 8 && hour < 17;

  return (
    <>
      <div className="success-payment-container">
        <div className="success-payment-content">
          {isDuringBusinessHours ? (
            <>
              <h3>{currentData?.personName}, your quote is on its way!</h3>
              <p>One of our pool care experts will give you a call shortly to confirm the details. If we're not able to reach you, we'll send your personalized quote to your inbox within 15 minutes. We can't wait to get your pool sparkling!</p>
            </>
          ) : (
            <>
              <h3>{currentData?.personName}, your quote is on its way!</h3>
              <p>We're sending your personalized quote to your inbox now. Our team will follow up with you during business hours to answer any questions and get your pool sparkling!</p>
            </>
          )}
          <button onClick={(e) => { e.preventDefault(); window.location.href = 'https://cabanapools.com/'; }} className="no-decoration btn btn-next">
            <span >RETURN HOME</span>
          </button>

        </div>
        <img src="/images/postermock.svg" alt="Success Payment" className="success-payment-image" />
      </div>
      <input type="hidden" id="progress_slide_1" data-width="100%" />
    </>
  )
}

export default QuoteConfirmation
